module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/colorado-state-university-1ae74f482383ac13a449be9fc2b7f4e9.svg";